import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { switchMap, take } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Adjunta `Authorization: Bearer <ID token>` a toda petición HttpClient
 * dirigida al API de AMAIA (`environment.url`, que también es prefijo de
 * `notesUrl` y `logsUrl`). El backend valida el JWT contra el JWKS de
 * CloudGate/LobbyCloudGate (reporte de seguridad #3863384).
 *
 * Con `bypassAuth` activo no hay sesión, así que la petición sale sin
 * header. Peticiones a otros orígenes (S3 presignado, CDNs) no se tocan.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.bypassAuth || !req.url.startsWith(environment.url)) {
    return next(req);
  }

  const auth0 = inject(AuthService);
  return auth0.idTokenClaims$.pipe(
    take(1),
    switchMap((claims) => {
      const token = claims?.__raw;
      if (!token) {
        return next(req);
      }
      return next(
        req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      );
    })
  );
};
